import { render, staticRenderFns } from "./PlayingCard.vue?vue&type=template&id=2cf77e51&scoped=true"
import script from "./PlayingCard.vue?vue&type=script&lang=js"
export * from "./PlayingCard.vue?vue&type=script&lang=js"
import style0 from "./PlayingCard.vue?vue&type=style&index=0&id=2cf77e51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf77e51",
  null
  
)

export default component.exports